import Decimal from 'decimal.js';
import { Moment } from 'moment';
import { Currency } from './currency';
export class PaymentOrder {

    constructor(
        public amount: Decimal,
        public amountInEuro: Decimal | null,
        public dueDate: Moment,
        public currency: Currency,
        public id?: number,
        public invoiceNumber?: string,
        public label?: string
    ){}
}
